import { ModalHeader, ModalBody, Button, ModalFooter, Modal } from "reactstrap";

const ConfirmationAlertTwo = ({ openModal, stayModal, leaveModal, suppMessage, onDeleteSuplierBrand }) => {

  return <Modal isOpen={openModal} backdrop="static">
    <ModalHeader className="custom_header_colourTwo font-weight-bold align-items-center " toggle={stayModal}>
      <h3 className="mb-0 " style={{color:"white",fontSize:"20px"}}>Alert message!!</h3>
    </ModalHeader>
    {suppMessage?.id ?
      <ModalBody>
        <p className="card-just-text text-danger">
          Are you sure ?
        </p>
        <p>{"You wants to delete this!!"}</p>
      </ModalBody>
      :
      <ModalBody>
        <p className="card-just-text text-danger">
          Do you want to leave?
        </p>
        <p>{"Changes you made may not be saved."}</p>
      </ModalBody>
    }
    {suppMessage?.id ?
      <ModalFooter>
        <Button type="button" color="secondary" onClick={stayModal}>No</Button>{' '}
        <Button type="button" color="primary" onClick={onDeleteSuplierBrand}>Yes</Button>
      </ModalFooter>
      :
      <ModalFooter>
        <Button type="button" color="secondary" onClick={stayModal}>Stay</Button>{' '}
        <Button type="button" className="btn btn-primaryTwo" onClick={leaveModal}>Leave</Button>
      </ModalFooter>
    }
  </Modal>
}

export default ConfirmationAlertTwo;
